import { Component } from '@angular/core';
import { TokenData } from '../services/oauth2-service';
import { LoginObjectService } from '../services/login-object.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Storage } from '@ionic/storage-angular';
import { Subscription } from 'rxjs';
import { MqttService } from '../services/mqtt.service';
import { environment } from 'src/environments/environment';
import { LoginObject } from 'src/assets/data/interfaces/user.interface';
import { ApiService } from '../services/api.service';
import { ModalController, Platform } from '@ionic/angular';
import { BlockedComponent } from '../modal/blocked/blocked.component';
import { UtilService } from '../services/util.service';
import { FontAwesomeService } from '../services/fontawesome.service';
import { StorageService } from '../services/storage.service';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage {

  showPassword = false;
  username;
  password;
  error = '';
  version;
  hideFooter = false;
  checked: boolean = false;
  isBlocked: boolean = false;
  currentUser: LoginObject = {
    username: '',
    password: '',
    captchaToken: '',
    email: '',
    roles: [],
    userId: undefined,
    clientes: [],
    bloqueado: [],
    mostrarOfertas: null,
    sessionTime: null,
  };

  estado: any = 0;

  showExtraLogos: boolean = true;
  subscriptions: Subscription[] = [];

  loginLoading: boolean;

  loginObject;

  versionLoading: boolean = true;
  latestVersion: any;
  apkDownloadUrl: any;
  politicaCheck = false;

  constructor(
    private tokenData: TokenData,
    private loginObjectService: LoginObjectService,
    private router: Router,
    private activateRoute: ActivatedRoute,
    public storage: Storage,
    private mqttService: MqttService,
    public apiService: ApiService,
    private modalController: ModalController,
    public utilService: UtilService,
    public faService: FontAwesomeService,
    public platform: Platform,
    public storageService: StorageService,
  ) {
    this.version = environment.version;
  }

  checkChange(e) {
    this.checked = e.checked;
  }

  changePolitica(e) {
    if (e.checked) {
      localStorage.setItem("politica", "True")
    } else {
      localStorage.removeItem("politica")
    }

  }

  ionViewWillEnter() {
    this.checkApkVersion();
    if (localStorage.getItem("politica")) {
      this.politicaCheck = true
    }

    localStorage.removeItem("mqttToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("token");
    this.storage.remove("user");

    this.activateRoute.queryParams.subscribe(params => {
      if (params['blocked'] === 'true') {
        this.isBlocked = true;
        this.presentBlockedModal();
      }
    });
    try { this.mqttService.desconectar(); }
    catch (error) { console.log("error al intentar desconectar del servicio mqtt", error) }

    // Redireccion desde MODX
    this.activateRoute.queryParams.subscribe(data => {
      if (data.access_token) {
        this.tokenData.checkTokenValidity(data.access_token).subscribe(data => {
          this.loginObjectService.loginObject = this.tokenData.processData(data);
          this.loginLoading = true;
          this.saveUser();
        }, error => {
          console.log("Error de auto login 1", error);
          this.loginLoading = false;
        });
      }
    });

    this.storage.get('private-data').then((val) => {
      if (val) {
        let aux = this.loginObjectService.decrypt(val);
        this.username = aux.user;
        this.password = aux.pass;
        this.checked = true;
        // login automatico ▼
        // this.tokenData.getToken(this.loginObject).subscribe((data) => {
        //   this.saveUser();
        // },
        //   (err) => {
        //     this.username = '';
        //     this.password = '';
        //     return this.error = 'Datos de validación incorrectos';
        //   });
      }
    })
  }

  ionViewDidEnter() { }

  async presentBlockedModal() {
    const modal = await this.modalController.create({
      component: BlockedComponent,
    });

    return await modal.present();
  }
  openPdf() {
    window.open(this.storageService.urlSpecies + 'politica.pdf', '_system')
  }
  validarUsuario() {
    this.error = '';
    if (!this.username || null == this.username || this.username == '') {
      return this.error = 'Debe introducir su nombre de usuario';
    }
    if (!this.password || null == this.password || this.password == '') {
      return this.error = 'Debe introducir su contraseña';
    }
    if (!localStorage.getItem("politica")) {
      return this.error = 'Debe aceptar la política de privacidad';
    }
    if (this.error == '') {
      this.loginLoading = true;
      this.loginObjectService.setUsername(this.username);
      this.loginObjectService.setPassword(this.password);
      this.tokenData.login(this.loginObjectService).subscribe((data) => {
        this.tokenData.processData(data);
        if (this.checked) {
          this.storage.set('private-data', this.loginObjectService.encrypt({ "user": this.username, "pass": this.password }));
        } else {
          this.storage.remove('private-data');
        }
        this.saveUser();
      }, (err) => {
        console.log(err);
        this.password = '';
        this.loginLoading = false;
        return this.error = 'Datos de validación incorrectos o usuario ya conectado';
      });
    }
  }

  recuperarContrasenha() {
    this.router.navigate(['/recupera-contrasenha']);
  }

  private saveUser() {
    this.loginObjectService.setPassword(""); // Limpieza de password para que no se guarde en localstorage
    if (!this.storage.get("showTimeDifference")) { this.storage.set("showTimeDifference", false); }
    // if (this.storageService.isWeb == false && this.latestVersion != this.version) { this.loginObjectService.setBloqueado(["NOSUBASTA"]); } //LIMITACION DEL MENU SI EL USUARIO ENTRA CON VERSION ATRASADA
    this.storage.set("user", this.loginObjectService.loginObject).then(() => {
      if (this.loginObjectService.loginObject.bloqueado.includes('NOSUBASTA')) {
        this.router.navigateByUrl('/compras', { replaceUrl: true });
      } else {
        this.mqttService.conexion(this.loginObjectService.loginObject.userId, this.loginObjectService.loginObject.username);
        this.router.navigateByUrl('/listado-subastas', { replaceUrl: true });
      }
    }, error => {
      this.loginLoading = false;
    });
  }

  public toggleShowPass() {
    if (this.showPassword) {
      this.showPassword = false;
    } else {
      this.showPassword = true;
    }
  }

  logoLoadError(event) {
    this.showExtraLogos = false;
  }

  checkApkVersion() {
    this.versionLoading = true;
    if (this.storageService.isWeb == false) {
      this.apiService.getApkStatus().subscribe({
        next: (result) => {
          this.latestVersion = result["apk-ClienteVersion"];
          this.apkDownloadUrl = this.storageService.isIOS == true ? result["apk-ClienteRutaIOS"] : result["apk-ClienteRuta"];
        },
        error: (e) => { console.log(e); this.versionLoading = false; },
        complete: () => { this.versionLoading = false; }
      }
      );
    } else {
      this.versionLoading = false;
    }
  }

  getNewVersion() {
    let browser = new InAppBrowser().create(this.apkDownloadUrl, '_system');
    browser.close();
    try { navigator['app'].exitApp(); } // Se cierra automaticamente la app
    catch (error) { console.log("Error de salida forzada de la app. ", error); }
  }
}